import { links } from '../brand';
import { PlatformIcon, brandHex } from './PlatformIcon';

/**
 * Squircle brand-color tiles, two per row. Hovering one tile dims the others
 * (CSS, see .links__list:hover) and reveals a ↗ "opens in a new tab" cue,
 * inline with the label.
 */
export function LinkHub() {
  return (
    <section className="links" aria-label="DJ Longbeard everywhere">
      <h2 className="links__head">Find me everywhere</h2>
      <nav className="links__list">
        {links.map((link) => {
          const isMail = link.url.startsWith('mailto:');
          return (
          <a
            key={link.icon}
            className="link"
            href={link.url}
            target={isMail ? undefined : '_blank'}
            rel={isMail ? undefined : 'noopener noreferrer'}
          >
            <span className="link__tile" style={{ background: link.tile ?? brandHex(link.icon) }}>
              <PlatformIcon slug={link.icon} />
            </span>
            <span className="link__label">{link.label}</span>
            <span className="sr-only">{isMail ? '(opens your email app)' : '(opens in a new tab)'}</span>
            <span className="link__out" aria-hidden="true">
              <svg className="link__arrow" viewBox="0 0 24 24" width="18" height="18">
                <path
                  d="M7 17L17 7M9 7h8v8"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <span className="link__tip" aria-hidden="true">{link.tagline}</span>
          </a>
          );
        })}
      </nav>
    </section>
  );
}
